import { action, createRequestTypes } from '@/utils/actions.utils'
import { supportService, userService } from '@/services'
import { uiActions } from '@/redux/actions'

export const FETCH_SUPPORT_SUBJECTS = createRequestTypes('FETCH_SUPPORT_SUBJECTS')
const fetchSupportSubjects = ({ catalogId, lang, roles }) => {
	return async (dispatch) => {
		try {
			await dispatch(request())

			const res = await supportService.fetchSupportSubjects({ catalogId, lang, roles })
			return dispatch(success(res.data))
		} catch (error) {
			return dispatch(failure(error))
		}
	}

	function request() {
		return action(FETCH_SUPPORT_SUBJECTS.REQUEST)
	}
	function success(payload) {
		return action(FETCH_SUPPORT_SUBJECTS.SUCCESS, payload)
	}
	function failure(err) {
		return action(FETCH_SUPPORT_SUBJECTS.FAILURE, null, err)
	}
}

export const SEND_REQUEST_BUDGET_USA = createRequestTypes('SEND_REQUEST_BUDGET_USA')
const sendRequestBudgetUsa = ({ siteLocation, catalogId, lang, project, changeProjectName }) => {
	return async (dispatch) => {
		try {
			await dispatch(request())
			const res = await supportService.sendRequestBudgetUsa({
				siteLocation,
				catalogId,
				lang,
				project,
				changeProjectName
			})
			dispatch(success(res.data))
			return dispatch(uiActions.setActionDone(action(SEND_REQUEST_BUDGET_USA.SUCCESS, res.data)))
		} catch (error) {
			dispatch(failure(error))
			return dispatch(uiActions.setActionDone(action(SEND_REQUEST_BUDGET_USA.FAILURE, null, error)))
		}

		function request() {
			return action(SEND_REQUEST_BUDGET_USA.REQUEST)
		}
		function success(payload) {
			return action(SEND_REQUEST_BUDGET_USA.SUCCESS, payload)
		}
		function failure(err) {
			return action(SEND_REQUEST_BUDGET_USA.FAILURE, null, err)
		}
	}
}

export const FETCH_BUSINESS_ACTIVITIES_TYPE = createRequestTypes('FETCH_BUSINESS_ACTIVITIES_TYPE')
const fetchBusinessActivitiesType = ({ lang }) => {
	return async (dispatch) => {
		try {
			await dispatch(request())

			const res = await userService.fetchBusinessActivitiesType({ lang })
			return dispatch(success(res.data))
		} catch (error) {
			return dispatch(failure(error))
		}

		function request() {
			return action(FETCH_BUSINESS_ACTIVITIES_TYPE.REQUEST)
		}
		function success(payload) {
			return action(FETCH_BUSINESS_ACTIVITIES_TYPE.SUCCESS, payload)
		}
		function failure(err) {
			return action(FETCH_BUSINESS_ACTIVITIES_TYPE.FAILURE, null, err, false)
		}
	}
}

export const HIDE_USA_BUDGET_MODAL_CONFIRMACION = 'HIDE_USA_BUDGET_MODAL_CONFIRMACION'
const hideUsaBudgetModalConfirmation = (payload) => {
	return action(HIDE_USA_BUDGET_MODAL_CONFIRMACION, payload)
}

export const SUPPORT_REQUESTED_SUCCESS = 'SUPPORT_REQUESTED_SUCCESS'
const supportRequestedSuccess = (payload) => {
	return action(SUPPORT_REQUESTED_SUCCESS, payload)
}

export const SUPPORT_REQUESTED_FAILURE = 'SUPPORT_REQUESTED_FAILURE'
const supportRequestedFailure = (payload) => {
	return action(SUPPORT_REQUESTED_FAILURE, payload)
}

export default {
	fetchSupportSubjects,
	fetchBusinessActivitiesType,
	supportRequestedSuccess,
	supportRequestedFailure,
	hideUsaBudgetModalConfirmation,
	sendRequestBudgetUsa
}
